<script lang="ts">
  import TimeInput from "../TimeInput.svelte"
  import { TrashIcon } from "@rgossiaux/svelte-heroicons/solid"
  import Checkbox from "../../../Base/Checkbox.svelte"
  import Tr from "../../../Base/Tr.svelte"
  import { Stores, UIEventSource } from "../../../../Logic/UIEventSource"
  import Translations from "../../../i18n/Translations"
  import { OH } from "../../../OpeningHours/OpeningHours"
  import { Lists } from "../../../../Utils/Lists"
  import { Translation } from "../../../i18n/Translation"
  import PlusCircle from "@babeard/svelte-heroicons/mini/PlusCircle"

  export let value: UIEventSource<string>

  const wt = Translations.t.general.weekdays.abbreviations
  /*
  Single rule for collection times, e.g. "Mo-Fr 10:00, 17:00"
   */
  let weekdays: Translation[] = [
    wt.monday,
    wt.tuesday,
    wt.wednesday,
    wt.thursday,
    wt.friday,
    wt.saturday,
    wt.sunday,
    Translations.t.general.opening_hours.ph,
  ]

  let initialTimes = Lists.noEmpty(
    value.data
      ?.split(" ")?.[1]
      ?.split(",")
      ?.map((s) => s.trim()) ?? []
  )
  let values = new UIEventSource(initialTimes.map((t) => new UIEventSource(t)))
  if (values.data.length === 0) {
    values.data.push(new UIEventSource(""))
  }

  let daysOfTheWeek = [...OH.days, "PH"]
  let selectedDays = daysOfTheWeek.map(() => new UIEventSource(false))

  let initialDays = Lists.noEmpty(value.data?.split(" ")?.[0]?.split(",") ?? [])
  for (const initialDay of initialDays) {
    if (initialDay.indexOf("-") > 0) {
      let [start, end] = initialDay.split("-")
      let startindex = daysOfTheWeek.indexOf(start)
      let stopindex = daysOfTheWeek.indexOf(end)
      for (let i = startindex; i <= stopindex; i++) {
        selectedDays[i]?.set(true)
      }
    } else {
      let index = daysOfTheWeek.indexOf(initialDay)
      if (index >= 0) {
        selectedDays[index]?.set(true)
      }
    }
  }

  let selectedDaysBound = Stores.concat(selectedDays).mapD((days) =>
    Lists.noNull(days.map((selected, i) => (selected ? daysOfTheWeek[i] : undefined)))
  )
  let valuesConcat: Store<string[]> = values
    .bindD((values) => Stores.concat(values))
    .mapD((values) => Lists.noEmpty(values))
  valuesConcat
    .mapD(
      (times) => {
        console.log(times)
        times = Lists.noNull(times)
        if (!times || times?.length === 0) {
          return undefined
        }
        times?.sort(/*concatted, new array*/)
        return (Lists.noEmpty(selectedDaysBound.data).join(",") + " " + times).trim()
      },
      [selectedDaysBound]
    )
    .addCallbackAndRunD((v) => value.set(v))

  function selectWeekdays() {
    for (let i = 0; i < 5; i++) {
      selectedDays[i].set(true)
    }
    for (let i = 5; i < selectedDays.length; i++) {
      selectedDays[i].set(false)
    }
  }

  function clearDays() {
    for (let i = 0; i < selectedDays.length; i++) {
      selectedDays[i].set(false)
    }
  }
</script>

<div class="low-interaction my-2 flex w-full flex-wrap justify-between rounded-xl p-2">
  <div class="flex flex-col">
    <div class="flex flex-wrap">
      {#each $values as value, i}
        <div class="mx-4 flex items-center gap-x-1">
          <TimeInput {value} />
          {#if $values.length > 1}
            <button class="as-link">
              <TrashIcon class="h-6 w-6" />
            </button>
          {/if}
        </div>
      {/each}
      <button
        on:click={() => {
          values.data.push(new UIEventSource(undefined))
          values.ping()
        }}
      >
        <PlusCircle class="h-6 w-6" />
        <Tr t={Translations.t.collectionTimes.addTime} />
      </button>
    </div>
    <div class="flex w-fit flex-wrap">
      {#each daysOfTheWeek as day, i}
        <div class="w-fit">
          <Checkbox selected={selectedDays[i]}>
            <Tr t={weekdays[i]} />
          </Checkbox>
        </div>
      {/each}
    </div>
  </div>
  <div class="flex w-full flex-wrap justify-between">
    <div class="flex flex-wrap gap-x-4">
      <button class="as-link text-sm" on:click={() => selectWeekdays()}>Select weekdays</button>
      <button class="as-link text-sm" on:click={() => clearDays()}>Clear days</button>
    </div>
    <slot name="right" />
  </div>
</div>
